import styled from "styled-components";

const Button = styled.button`
  border: solid 1px #ccc;
  line-height: 2;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: #212529;
  color: #fff;
  width: 100%;
  margin-bottom: 12px;
`;
export default Button;
